import React from 'react'
import { useEvent, useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import { Select } from '../components'
import { BannerStatic } from '../../../components'

const DEFAULT = [
  { code: 'nova-annual', name: 'Annual' },
  { code: 'nova-monthly', name: 'Monthly' },
  { code: 'nova-multi-year', name: 'Multi-Year' }
]

const SubscriptionInput = ({ control }) => {
  const [options, setOptions] = React.useState(DEFAULT)

  const [listPlans] = useEvent([
    {
      eventName: 'subscriptionListPlans',
      onSuccess: payload => {
        setOptions(payload.plans.map(({ code, name }) => ({ code, name })))
      },
      onError: e => {
        console.error('Error while attempting to get the current subscription plans', e)
        BannerStatic.show({
          label: 'Error while attempting to get the current subscription plans',
          isError: true
        })
      }
    }
  ])

  useEventsOnViewLoad(() => {
    listPlans.trigger()
  }, [listPlans])

  return (
    <Select
      name='code'
      control={control}
      loading={listPlans.isWorking}
      options={options.map(opt => opt.code)}
      renderOption={(code) => options.find(opt => opt.code === code).name}
      data-test='select-subscription-plan-input'
    />
  )
}

export default SubscriptionInput
